import {DataGrid, GridToolbar} from "@mui/x-data-grid";
function ERPDataGrid(props) {
    return (
        <DataGrid

            {...props}

            autoHeight

            disableRowSelectionOnClick

            pageSizeOptions={[10, 25, 50, 100]}

            slots={{
                toolbar: GridToolbar
            }}

            getRowHeight={() => "auto"}

            sx={{
                border: 0,
                borderRadius: 12,
                boxShadow: "0 8px 30px rgba(0,0,0,.08)",
                "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#1B5E20",
                    color: "#fff"
                },
                "& .MuiDataGrid-cell": {
                    borderBottom: "1px solid #f3f4f6",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    lineHeight: "20px",
                    display: "flex",
                    alignItems: "center",
                    paddingTop: "10px",
                    paddingBottom: "10px"
                },
                "& .MuiDataGrid-row:hover": {
                    background: "#f4fff6"
                },
                ...props.sx
            }}

        />
    );
}
export default ERPDataGrid;